fx.ns("shared.components", class HelpBubble extends  fx.EventDispatcher 
{
    constructor(surface)
    {
        super();

        this._surface = surface;
        this._currentBubble;
        this._currentElement;
        this._bubbleHeight = 130;
        this._bubbleWidth = 250;
        this._arrowWidth = fx.browser.isDesktop ? 20 : 30;
        this._arrowHeight = fx.browser.isDesktop ? 30 : 20;
        this._screenOffset = 10;
        this._elementOffset = 5;
    }

    show(element, title, text, width, height)
    {
        if (this._currentBubble)
            this.close();

        this._currentElement = element;

        this._currentBubble = new fx.components.Box("HelpBubble");
        this._currentBubble.effect = "scale";
        this._currentBubble.addChild(new fx.components.Text({className : "title center", text : title}), { width : "100%", height : 30, top: 23, left : 0});
        this._currentBubble.addChild(new fx.components.Text({className : "text center", text : text}), { width : "100%", height : 60, top: 58, left : 10, right : 10});

        this._arrow = new fx.components.Box("arrow");
        
        this._currentBubble.addChild(this._arrow);
        this._surface.addChild(this._currentBubble);

        this._setPositions(this._currentElement, width, height);

        this._listenEvents(true);
        this.delay(this.close, 7000);
    }

    _setPositions(element, width, height)
    {
        let scale = fx.graphics.getScale(element);
        let elementPosition = fx.dom.offset( element);
        let elementHeight = fx.dom.height(element) * scale;
        let elementWidth = fx.dom.width(element) * scale;
        width = width || this._bubbleWidth;
        height = height || this._bubbleHeight;

        if (!elementPosition)
            return;
        
        if (fx.browser.isDesktop)
        {
            let positionLeft = (elementPosition.left + elementWidth) < this._surface.realWidth/2;
            let left = positionLeft ? elementPosition.left + elementWidth + this._screenOffset : elementPosition.left - width - this._screenOffset;
            let top = elementPosition.top + (elementHeight / 2) - (height/2);
            
            let bubblePosition = {width : width, height :height, left : left, top : top};

            
            if (top + height > this._surface.realHeight)
                top = this._surface.realHeight - height - this._screenOffset;
            else
            if (left < 0)
                top = this._screenOffset;

            let arrowTop = (height / 2) - (this._arrowHeight/2);
            let arrowPosition =  { width : 0, height : 0, top : arrowTop};

            if (positionLeft)
            {
                arrowPosition.left = -this._arrowWidth;
            }
            else
            {
                arrowPosition.right = -this._arrowWidth;
            }

            this._currentBubble.toggleClass("left", positionLeft);
            this._currentBubble.toggleClass("right", !positionLeft);
            
            this._arrow.viewport(arrowPosition);
            this._currentBubble.viewport(bubblePosition);
        }
        else
        {
            let left = elementPosition.left + (elementWidth / 2) - (width / 2);
            // case when element is too near from the borders, and bubble might be displayed partially outside
            if (left + width > this._surface.realWidth)
                left = this._surface.realWidth - width - this._screenOffset;
            else
            if (left < 0)
                left = this._screenOffset;

            let arrowLeft = Math.min( Math.max(this._screenOffset, elementPosition.left - left + (elementWidth / 2) - this._arrowWidth/2), width - this._arrowWidth - this._screenOffset);

            let bubblePosition = {width : width, height :height, left : left};
            let arrowPosition =  { width : 0, height : 0, left : arrowLeft};
            let positionBottom = elementPosition.top > this._surface.realHeight / 2;

            this._currentBubble.toggleClass("bottom", positionBottom);
            this._currentBubble.toggleClass("top", !positionBottom);

            // add at the bottom
            if (positionBottom)
            {    
                bubblePosition.top = elementPosition.top -height - this._arrowHeight - this._elementOffset;
                arrowPosition.bottom = -this._arrowHeight + 1;
            }
            else // add at the top
            {
                bubblePosition.top = elementPosition.top + elementHeight + this._arrowHeight + this._elementOffset;
                arrowPosition.top = -this._arrowHeight+1;
            }

            this._arrow.viewport(arrowPosition);
            this._currentBubble.viewport(bubblePosition);
        }
        
    }


    close()
    {
        if (this._currentBubble)
        {
            this._currentBubble.hideDestroy();
            this._currentBubble = null;

            this._listenEvents(false)
        }
    }

    _listenEvents(val)
    {
        if (val)
        {
            if (fx.browser.isDesktop)
                this.on("click", this.onTap, this._surface);
            else
                this.on("touchStart", this.onTap, this._surface);

            this.on("view-scrolled", this.onScroll, this._surface);    
        }
        else
        {
            if (fx.browser.isDesktop)
                this.off("click", this.onTap, this._surface);
            else
                this.off("touchStart", this.onTap, this._surface);

            this.off("view-scrolled", this.onScroll, this._surface);
        }
    }


    onTap(e)
    {
        this.close();
    }

    onScroll()
    {
        if(this._currentBubble)
            this._setPositions(this._currentElement);
    }


});
